export default __webpack_public_path__ + "static/media/dashboard_banner_01.1afb31b8.png";